import { createGlobalStyle } from 'styled-components';
import { visuallyHidden } from './accessibility';
import fonts from './fonts';
import { otherColors } from './colors';

export default createGlobalStyle`
  :root {
    font-size: ${fonts.baseSize * 100}%;

  ${({ theme }) => Object.keys(theme.screenSize).map((screenSize) => {
    const screenSizeObject = theme.screenSize[screenSize as keyof typeof theme.screenSize];
    const prefix = screenSize === 's380' ? '' : `${screenSizeObject.mediaQuery} {`;
    const suffix = screenSize === 's380' ? '' : '}';

    return `
      ${prefix}
        --global-grid-column-count: ${screenSizeObject.gridColumns};
        --global-grid-column-gap: ${screenSizeObject.gridColumnGap};
        --global-grid-horizontal-padding: ${screenSizeObject.gridHorizontalPadding};
        --global-grid-max-width: ${theme.screenSize.s1366.size};
        --global-grid-size: ${screenSizeObject.size};
      ${suffix}
    `;
  })}
  }

  body {
    font-size: ${fonts.bodySize}rem;
    background: ${otherColors.background};
    color: ${otherColors.text};
  }

  del {
    &::after {
      ${visuallyHidden}
      content: " (end deleted text) ";
    }

    &::before {
      ${visuallyHidden}
      content: " (begin deleted text) ";
    }
  }

  s {
    &::after {
      ${visuallyHidden}
      content: " (end stricken text) ";
    }

    &::before {
      ${visuallyHidden}
      content: " (begin stricken text) ";
    }
  }

  #onetrust-consent-sdk {
    position: fixed;
    z-index: 2147483645;
  }

  #onetrust-consent-sdk, #onetrust-banner-sdk {
    #onetrust-pc-sdk.otRelFont, #onetrust-reject-all-handler , #onetrust-pc-btn-handler{
      font-size: 1.6rem !important;
    }
    ${fonts.sohne.regular}
    h3#onetrust-policy-title {
      ${fonts.sohne.semibold}
    }
    button {
      border-radius: 50rem !important;
      opacity: 1 !important;
      font-weight: 500 !important;
    }

    #onetrust-policy-title {
      font-size: 1.6rem !important;

      @media screen and (min-width: 576px) {
        font-size: 1.8rem !important;
      }
    }

    #onetrust-policy-text {
      font-size: 1.2rem !important;

      @media screen and (min-width: 576px) {
        font-size: 1.4rem !important;
      }
      
    }
    .ot-close-icon {
      padding-left: 3rem !important;
    }
  }

  /* Google reCAPTCHA needs to be above OneTrust on the signup form */
  div:has(.g-recaptcha-bubble-arrow) {
    z-index: 2147483647 !important;
  }
`;
